/**
 * #282 — the camera "number" drawn inside a map pin: the first run of digits in the camera
 * name, kept as written (so "0760 Market Lane" shows "0760"). The same rule orders the
 * Cameras page by number (item 277). Null when the name has no digits. A run longer than four
 * digits (an IMEI-like name) shows its last four, which is what fits in the pin head.
 */
export function cameraNumber(name: string | null | undefined): string | null {
  const match = /\d+/.exec(name ?? '')
  if (!match) return null
  const digits = match[0]
  return digits.length > 4 ? digits.slice(-4) : digits
}
